import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	legalTitle: {
		id: 'fastshift.legal-banner.title',
		defaultMessage: 'FastShift Portal use agreement',
		description: 'Title for Legal banner about usage agreement',
	},
	legalDescription: {
		id: 'fastshift.legal-banner.description',
		defaultMessage:
			'By using this FastShift Portal, you agree that its use is governed by the {CustomerAgreementLink} and the {PrivacyPolicyLink}. This FastShift Portal is considered to be a “Free or Beta product” under Section 17 of the Atlassian Customer Agreement.',
		description: 'Description for Legal banner about usage agreement',
	},
	atlassianCustomerAgreementLinkText: {
		id: 'fastshift.legal-banner.customer-agreement-link-text',
		defaultMessage: 'Atlassian Customer Agreement',
		description: 'link text for link to Atlassian Customer Agreement',
	},
	atlassianPrivacyPolicyLinkText: {
		id: 'fastshift.legal-banner.privacy-policy-link-text',
		defaultMessage: 'Atlassian Privacy Policy',
		description: 'link text for link to Atlassian Privacy Policy',
	},
});
